import DownloadIcon from "@mui/icons-material/Download";
import { Box, IconButton, Skeleton, Typography } from "@mui/material";
import html2canvas from "html2canvas";
import { useRef, useState } from "react";
import { Chart } from "react-google-charts";
import { useTranslation } from "react-i18next";
import strings from "../../../../../global/constants/StringConstants";
import { selectRole } from "../../../../../redux/authSlice";
import { useAppSelector } from "../../../../../utils/hooks";
import { regularFont } from "../../../../../utils/styles";
import nakshatraStyles from "../Nakshatra.styles";

interface CustomProps {
  data: any[];
  title: string;
  slices: any[];
  maxData: any[];
  placeColor?: string;
}

const PieChart = (props: CustomProps) => {
  const classes = nakshatraStyles;
  const { t } = useTranslation();
  const role = useAppSelector(selectRole);
  const chartRef = useRef<HTMLDivElement>(null);
  const [hideDownload, setHideDownload] = useState(false);

  const options = {
    title: props.title,
    titleTextStyle: { ...regularFont, color: "#fff" },
    is3D: true,
    pieStartAngle: 0,
    legend: {
      position: "labeled",
      textStyle: { ...regularFont, color: "white", bold: 1, fontSize: 16 },
    },
    pieHole: 0.1,
    pieSliceTextStyle: {
      ...regularFont,
      color: props.placeColor ? props.placeColor : "#fff",
    },
    slices: props.slices,
    export: { enabled: true },
  };

  const handleDownload = async () => {
    setHideDownload(true);
    await new Promise((resolve) => setTimeout(resolve, 100));
    if (chartRef.current) {
      const canvas = await html2canvas(chartRef.current, {
        backgroundColor: "#222",
        useCORS: true,
      });
      const link = document.createElement("a");
      link.href = canvas.toDataURL("image/png");
      link.download = `${props.title}.png`;
      link.click();
    }
    setHideDownload(false);
  };

  return (
    <div className="chart-container" style={{ position: "relative" }}>
      {role === strings.ADMIN && !hideDownload && (
        <IconButton
          sx={{
            position: "absolute",
            top: 10,
            right: 10,
            backgroundColor: "rgba(255,255,255,0.8)",
            zIndex: 2,
          }}
          onClick={handleDownload}
        >
          <DownloadIcon htmlColor="#6B72FF" fontSize="large" />
        </IconButton>
      )}
      <div ref={chartRef}>
        <Chart
          width={"100%"}
          height={"400px"}
          chartType="PieChart"
          loader={
            <Box px={10} sx={{ display: "flex", justifyContent: "center" }}>
              <Skeleton
                variant="circular"
                width={500}
                height={400}
                sx={{
                  background: "#ffffff70",
                }}
              />
            </Box>
          }
          data={props.data}
          options={options}
          className="custom-pie-chart"
        />
      </div>
      {props.maxData.map((data: any, index: number) => {
        return (
          <Typography sx={classes.descriptionText} px={5} pb={2} key={index}>
            <u style={{ fontSize: "18px" }}>{data.key}:</u>{" "}
            {t(`${data.key.split(" ")[0].toLowerCase()}Details`)}
          </Typography>
        );
      })}
    </div>
  );
};

export default PieChart;
